/**
 * 对象操作系列函数
 */
import get from 'lodash/get';
import set from 'lodash/set';
import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';

const getValueByPath = {
    fn: (object, path, defaultValue) => {
        if (path) {
            return get(object, path, defaultValue);
        }
        return object;
    },
    desc: '输入三个参数(object, path, defaultValue)，如果path为假值返回object，否则调用lodash.get(object, path, defaultValue)',
};

const getConstantValueByPath = {
    fn: (path, object, defaultValue) => {
        return get(object, path, defaultValue);
    },
    desc: '输入三个参数(path, object, defaultValue)，调用lodash.get(object, path, defaultValue)',
};

const returnConstant = {
    fn: (a, constant) => {
        return constant;
    },
    desc: '输入两个参数(a, constant)，无视 a 并返回 constant 的值',
};

const returnConstantWithEqualCondition = {
    // eslint-disable-next-line max-params
    fn: (val, equalWith, a, b) => {
        return val === equalWith ? a : b;
    },
    desc: '输入四个参数(val, equalWith, a, b)，返回 val === equalWith ? a : b',
};
const arrayNormalizer = {
    fn: (arr, mapping = {}) => {
        if (Array.isArray(arr)) {
            if (!isEmpty(mapping)) {
                const resArr = arr.map(item => {
                    const resItem = isEmpty(item) ? cloneDeep(item) : {};
                    Object.keys(mapping).forEach(desPath => {
                        const srcPath = mapping[desPath];
                        set(resItem, desPath, get(resItem, srcPath));
                    });
                    return resItem;
                });
                return resArr;
            }
            return arr;
        }
        return [];
    },
    desc: '输入两个参数(arr, mapping)，mapping格式形如{ "label": "desc" }，输出中arr每一项label字段值为desc的值',
};

const cityOptionsToPickerData = {
    fn: (cityOptions = []) => {
        if (!Array.isArray(cityOptions)) {
            return [];
        }
        return cityOptions.map(provinceInfo => {
            const provinceObj = {
                text: provinceInfo.provinceName,
                value: provinceInfo.provinceId,
            };
            if (Array.isArray(provinceInfo.cities)) {
                provinceObj.children = provinceInfo.cities.map(cityInfo => ({
                    text: cityInfo.cityName,
                    value: cityInfo.cityCode,
                }));
            }
            return provinceObj;
        });
    },
    desc: '输入一个参数省市列表cityOptions, 输出sharp-ui picker组件能识别的数据格式',
};

export default {
    getValueByPath,
    getConstantValueByPath,
    returnConstant,
    returnConstantWithEqualCondition,
    arrayNormalizer,
    cityOptionsToPickerData,
};
